import React, { useState, useRef, useEffect, useCallback } from 'react';
import './ImageCompareSlider.css'; // Creeremo questo CSS dedicato

const ImageCompareSlider = ({
    beforeImage,
    afterImage,
    beforeLabel = 'PRIMA',
    afterLabel = 'DOPO'
}) => {
    const [sliderPosition, setSliderPosition] = useState(50); // Posizione iniziale al 50%
    const [isDragging, setIsDragging] = useState(false);
    const containerRef = useRef(null);

    const handleMove = useCallback((clientX) => {
        if (!containerRef.current) return;

        const rect = containerRef.current.getBoundingClientRect();
        // Calcola la posizione x del mouse/dito relativa al contenitore
        let x = clientX - rect.left;

        // Limita la posizione tra 0 e la larghezza del contenitore
        if (x < 0) x = 0;
        if (x > rect.width) x = rect.width;

        // Converte la posizione in percentuale e aggiorna lo stato
        setSliderPosition((x / rect.width) * 100);
    }, []); // useCallback per stabilità della funzione

    // Gestori per il mouse
    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        handleMove(e.clientX);
    };

    // Gestori per il tocco (mobile)
    const handleTouchStart = (e) => {
        setIsDragging(true);
    };

    const handleTouchEnd = () => {
        setIsDragging(false);
    };

    const handleTouchMove = (e) => {
        if (!isDragging) return;
        handleMove(e.touches[0].clientX);
    };

    // Aggiungi event listener globali per un'esperienza di trascinamento fluida
    useEffect(() => {
        // Questi listener globali assicurano che il trascinamento continui
        // anche se il cursore esce dal componente, e si ferma quando si rilascia il click ovunque.
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
        window.addEventListener('touchmove', handleTouchMove);
        window.addEventListener('touchend', handleTouchEnd);

        // Funzione di cleanup per rimuovere i listener quando il componente si smonta
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('touchmove', handleTouchMove);
            window.removeEventListener('touchend', handleTouchEnd);
        };
    }, [isDragging, handleMouseMove, handleMouseUp, handleTouchMove, handleTouchEnd]); // Aggiunta dipendenze

    return (
        <div ref={containerRef} className="image-compare-container">
            {/* Immagine "DOPO" (sopra) - la sua larghezza è controllata dallo slider */}
            <div
                className="compare-image after-image-wrapper"
                style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
            >
                <img src={afterImage} alt="Dopo" />
            </div>

            {/* Immagine "PRIMA" (sotto) */}
            <div className="compare-image before-image">
                <img src={beforeImage} alt="Prima" />
            </div>

            {/* Handle per il trascinamento */}
            <div
                className="slider-handle"
                style={{ left: `${sliderPosition}%` }}
                onMouseDown={handleMouseDown}
                onTouchStart={handleTouchStart}
            >
                <div className="slider-divider"></div>
                <div className="slider-button">
                    {/* --- SOSTITUISCI QUESTO BLOCCO SVG --- */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                      <path d="M7.646 1.646a.5.5 0 0 0 0 .708L13.293 8l-5.647 5.646a.5.5 0 0 0 .708.708l6-6a.5.5 0 0 0 0-.708l-6-6a.5.5 0 0 0-.708 0z"/>
                    </svg>
                    {/* --- FINE BLOCCO SVG --- */}
                </div>
            </div>

             {/* Etichette */}
             <div className="slider-label before-label">{beforeLabel}</div>
             <div className="slider-label after-label">{afterLabel}</div>
        </div>
    );
};

export default ImageCompareSlider;